import { createRoute } from '@tanstack/react-router';

import { useMaterialSearchStore } from '$/components/core/Collection/MaterialSearch/store/useMaterialSearchStore';
import { CollectionCategoryPage } from '$/pages/DashboardPages/pages/Collection/pages/CollectionCategoryPage';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';
import { useCollectionStore } from '$/stores/useCollectionStore';

export const FloorsCollectionRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/collections/floors',
  component: () => <CollectionCategoryPage materialType='floor_texture' />,
  loader: () => {
    useCollectionStore.setState({
      activeType: 'floor_texture',
      selectedViewMode: 'grid',
    });
    useMaterialSearchStore.setState({
      dropdownVisible: false,
    });
  },
  onLeave: () => {
    useCollectionStore.getState().resetAppliedFilter();
  },
  staleTime: 0,
});
